export const numberRound = (num, count = 3) =>
  Number(`${Math.round(+`${num}e${count}`)}e-${count}`);
